"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Blanket = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Blanket = function Blanket(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.913 4.424A2.037 2.037 0 0014.398 3H8.672a2.58 2.58 0 00-1.852.77C5.641 4.96 3.452 7.104 1.954 8.578h6.095c1.432 0 2.61 1.139 2.644 2.563l4.681-4.64c.556-.57.758-1.34.54-2.077z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.302 9.415c.1.201.151.436.151.687 0 .838-.69 1.524-1.532 1.524H2.374a.416.416 0 01-.42-.418c0-.235.185-.42.42-.42h4.547a.71.71 0 00.707-.703.71.71 0 00-.707-.703H1.819C.809 9.382 0 10.186 0 11.19S.808 13 1.819 13h6.23c1.01 0 1.819-.804 1.819-1.81 0-.904-.69-1.657-1.566-1.775z",
    fill: "currentColor"
  }));
};

exports.Blanket = Blanket;
var _default = Blanket;
exports.default = _default;